import { render } from "./FilterIcon.vue?vue&type=template&id=48c94ed2"
import script from "./FilterIcon.vue?vue&type=script&lang=js"
export * from "./FilterIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__